module.exports = __webpack_public_path__ + "img/28.83a4185f.jpg";